import type { CategoryWithCount } from '../types/category';
import type Category from '../types/category';

const getCategoryNodeWithCount = (
    node: Category,
    leafCounts: {
        category: {
            id: string;
        };
        total: number;
    }[]
): CategoryWithCount => {
    const leafCount = leafCounts.find(({ category: { id } }) => id === node.id);

    const children =
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        !!node.children && node.children.length > 0
            ? node.children.map(child =>
                  getCategoryNodeWithCount(child, leafCounts)
              )
            : [];

    return {
        ...node,
        children,
        count:
            (leafCount?.total ?? 0) + children.reduce((a, b) => a + b.count, 0),
    };
};

export default getCategoryNodeWithCount;
